import { use, useMemo } from 'react';

import type { ISlotsContext } from './context';
import { SlotsContext } from './context';

interface Props extends React.PropsWithChildren {
  slots: ISlotsContext;
}

export const SlotsProvider = (props: Props) => {
  const { slots, children } = props;
  const parentSlots = use(SlotsContext);
  const mergedSlots = useMemo(() => {
    const result = { ...parentSlots };

    // Merge the new slots with the parent slots (first level only)
    Object.entries(slots).forEach(([key, value]) => {
      if (typeof result[key] === 'object' && typeof value === 'object') {
        result[key] = { ...result[key], ...value };
      } else {
        result[key] = value;
      }
    });

    return result;
  }, [parentSlots, slots]);

  return <SlotsContext value={mergedSlots}>{children}</SlotsContext>;
};
